import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Tree } from '../../models/column-picker';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'app-column-picker-item',
  standalone: true,
  templateUrl: './column-picker-item.component.html',
  imports: [MatMenuItem, MatMenu, MatMenuTrigger, UpperCasePipe],
  styleUrl: './column-picker-item.component.scss'
})
export class ColumnPickerItemComponent {
  @ViewChild('childMenu') public childMenu!: MatMenu;
  @Input() items!: Tree[];
  @Output() selectedColumnKey = new EventEmitter<Tree>();
}
